/**
 * HAPPY TAILS Warm Theme — Stats Section
 * Supabase API から累計支援額・注文件数・連携保護団体数を取得して描画
 */
(function () {
  'use strict';

  function formatNumber(n) {
    return Number(n || 0).toLocaleString('ja-JP');
  }

  function update(root, data) {
    var amountEl = root.querySelector('[data-htw-stats-amount]');
    var ordersEl = root.querySelector('[data-htw-stats-orders]');
    var orgsEl = root.querySelector('[data-htw-stats-orgs]');
    if (amountEl && typeof data.amount === 'number') amountEl.textContent = formatNumber(data.amount);
    if (ordersEl && typeof data.orders === 'number') ordersEl.textContent = formatNumber(data.orders);
    if (orgsEl && typeof data.orgs === 'number') orgsEl.textContent = formatNumber(data.orgs);
  }

  function init() {
    var roots = document.querySelectorAll('[data-htw-stats]');
    roots.forEach(function (root) {
      var url = root.getAttribute('data-htw-stats-url');
      if (!url) return;
      fetch(url, { credentials: 'omit' })
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (data) { if (data) update(root, data); })
        .catch(function () { /* フォールバック値のまま表示 */ });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
